export const foundationDocuments = [
  "CHAS-COVID-19-Risk-Assessment-Guide-V2.pdf",
  "Contractor Checklist.pdf",
  "Contractor Method Statement Evaluation Sheet.pdf",
  "General Safety Audit.pdf",
  "Health & Safety Policy Contents.pdf",
  "Risk Assessment Template.pdf"
]
